module.exports = __webpack_public_path__ + "img/image_4.f69c5493.png";